import React from 'react';

const Section = ({ title, children }) => (
  <section className="static-section">
    <h2>{title}</h2>
    {children}
  </section>
);

export default function Terms() {
  return (
    <div className="static-page">
      <div className="static-page__hero">
        <h1>Terms of Use</h1>
        <p>Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
      </div>

      <div className="static-page__body">
        <Section title="1. Acceptance of Terms">
          <p>By accessing or using MK Classes ("the Platform"), you agree to be bound by these Terms of Use. If you do not agree, please do not use the Platform.</p>
        </Section>

        <Section title="2. Eligibility">
          <ul className="static-list">
            <li>You must be at least 13 years old to use the Platform.</li>
            <li>If you are under 18, you must have parental or guardian consent.</li>
            <li>You must provide accurate information when creating an account.</li>
          </ul>
        </Section>

        <Section title="3. User Roles">
          <ul className="static-list">
            <li><strong>Students</strong> may read notes, blogs, updates and instructions, watch videos, ask queries, and join personal sessions and group meetings.</li>
            <li><strong>Teachers</strong> are MK Classes staff. They publish content, answer queries and run sessions. Teacher accounts are created by the admin.</li>
            <li><strong>Admins</strong> manage the platform, add teachers, and monitor activity.</li>
          </ul>
        </Section>

        <Section title="4. Sessions & Meetings">
          <ul className="static-list">
            <li>Personal sessions and group meetings are held on specific dates and times.</li>
            <li>Meeting links are shared only with students who have joined.</li>
            <li>Videos are for viewing on the Platform only and must not be downloaded, recorded or shared.</li>
          </ul>
        </Section>

        <Section title="5. Payments">
          <p>Any fees are set by MK Classes. MK Classes is not responsible for disputes arising from payment errors caused by incorrect information provided by the user.</p>
        </Section>

        <Section title="6. Prohibited Conduct">
          <p>You must not:</p>
          <ul className="static-list">
            <li>Provide false information or impersonate another person</li>
            <li>Use the Platform for any unlawful purpose</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Attempt to gain unauthorised access to the Platform or its systems</li>
            <li>Post or share inappropriate, offensive, or copyrighted content</li>
          </ul>
        </Section>

        <Section title="7. Intellectual Property">
          <p>All content on the Platform,including notes, videos, UI design, and branding, is owned by MK Classes.</p>
        </Section>

        <Section title="8. Limitation of Liability">
          <p>MK Classes is not responsible for outcomes from using the Platform, such as exam results.</p>
        </Section>

        <Section title="9. Termination">
          <p>We reserve the right to suspend or terminate any account that violates these Terms, at our sole discretion and without prior notice.</p>
        </Section>

        <Section title="10. Changes to Terms">
          <p>We may update these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the new Terms.</p>
        </Section>

        <Section title="11. Contact">
          <p>For questions about these Terms, contact us at <strong>metkarianis09@gmail.com</strong>.</p>
        </Section>
      </div>
    </div>
  );
}
